import type { HelpFile } from '../../types/help'
import { IdentitySelectorTestIds } from '../../../testids/IdentitySelectorTestIds'

// Top-bar icon buttons — each carries its own aria-label/tooltip; a help
// popover next to a single-purpose icon adds noise. Convention check still
// requires an entry per static testid; `null` is the deliberate opt-out.
export const identitySelectorHelp: HelpFile = {
  docPage: '/docs/getting-started/dashboard',
  texts: {
    [IdentitySelectorTestIds.btnLogout]: null,
    [IdentitySelectorTestIds.btnProfile]: null,
    [IdentitySelectorTestIds.btnSwitchUser]: null,
  },
}
